// This gets the user token from local storage.  Returns the viewas if that's set, else the regular token.
export default function userToken() {
	let user = localStorage.getItem("user")
	let viewAs = localStorage.getItem("viewAs")
	if(viewAs) {
		return viewAs
	}
	else if(user) {
		return user
	}
	else {
		return false
	}
}